import type { SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { deriveFieldNameFromLabel } from '@core-engine/schema/add-field/derive-field-name-from-label.js'
import { validateGeneratedFieldName } from '@core-engine/schema/add-field/validate-generated-field-name.js'
import { promptText } from './prompt-text.js'

export async function promptFieldName(
  context: SchemaPromptContext,
  label: string
): Promise<string> {
  const defaultName = deriveFieldNameFromLabel(label)
  return promptText(context, 'Field name', {
    defaultValue: defaultName,
    validate(value) {
      const errors = validateGeneratedFieldName(String(value ?? ''))
      return errors[0]
    }
  })
}
